import React from 'react'
// ////////////////////////////////////////////////////////////////// COMPONENTS
import Icon from './icon'
// ////////////////////////////////////////////////////////////////// FLOW TYPES

// ////////////////////////////////////////////////////////////////// IMPORT END
// /////////////////////////////////////////////////////////////////////////////

type Props = {
  id?: string
  title?: string
  className?: string
  onClick?: Function
  style?: Record<string, string | number>
  width?: number
}

const Grid = ({
  id,
  title,
  className,
  onClick,
  style,
  width,
}: Props): React.ReactElement => {
  return (
    <Icon
      id={id || 'icon-grid'}
      sourceWidth={11}
      sourceHeight={12}
      title={title}
      className={className}
      onClick={onClick}
      style={style}
      viewBox="0 0 60 60"
      width={width}
    >
      <g strokeWidth="0">
        <path d="M45.5383 12.3077H16C13.9692 12.3077 12.3077 13.9692 12.3077 16V45.5384C12.3077 47.5692 13.9692 49.2308 16 49.2308H45.5383C47.5691 49.2308 49.2306 47.5692 49.2306 45.5384V16C49.2306 13.9692 47.5691 12.3077 45.5383 12.3077ZM23.3846 45.5384H16V38.1538H23.3846V45.5384ZM23.3846 34.4615H16V27.0769H23.3846V34.4615ZM23.3846 23.3846H16V16H23.3846V23.3846ZM34.4615 45.5384H27.0769V38.1538H34.4615V45.5384ZM34.4615 34.4615H27.0769V27.0769H34.4615V34.4615ZM34.4615 23.3846H27.0769V16H34.4615V23.3846ZM45.5383 45.5384H38.1538V38.1538H45.5383V45.5384ZM45.5383 34.4615H38.1538V27.0769H45.5383V34.4615ZM45.5383 23.3846H38.1538V16H45.5383V23.3846Z" />
      </g>
    </Icon>
  )
}

// /////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////// EXPORT DEFAULT
export default Grid
